import { api } from './API'
import { requireAuth } from './Auth'

/**
 * ワークスペースに紐づく全てのサービス情報を取得する
 *
 * @param id
 */
export const allServices = (id: number) =>
  requireAuth<any>(api.get(`workspaces/${id}`))
